import { useAddUnitInitialQuery, useAddUnitMutation } from "../../store/data/unitsSlice";
import { Redirect } from "react-router-dom";
import { LoadingOrb } from "../../components/LoadingOrb";
import { SomethingWentWrong } from "../../components/SomethingWentWrong";
import { NameOnlyForm } from "../../components/forms/NameOnlyForm";
import { DataLoadingWardenForQuery } from "../../components/DataLoadingWardenForQuery";

class ContainerProps {}

export const UnitAddForm: React.FC<ContainerProps> = () => {
    const initial = useAddUnitInitialQuery({});
    const [add, result] = useAddUnitMutation();

    if (result.isLoading) {
        return <LoadingOrb text="Zapisuję..." />;
    }
    if (result.error && result.error?.status !== 400) {
        return <SomethingWentWrong text="Coś poszło nie tak :(" />;
    }
    if (result.isSuccess) {
        return <Redirect to="/dictionaries/units" />;
    }

    return (
        <div className="unit-add-form-component form-content">
            <DataLoadingWardenForQuery query={initial}>
                {() => (
                    <NameOnlyForm
                        data={result.originalArgs?.body || initial.data}
                        submitForm={(data) => add({ body: data })}
                        errors={result.error?.data || {}}
                    />
                )}
            </DataLoadingWardenForQuery>
        </div>
    );
};
